module.exports = __webpack_public_path__ + "static/media/iwaypoint.ce923756.svg";